var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-avatar",class:[_vm.size ? 'my-avatar__' + _vm.size : '']},[(!_vm.img)?_c('span',{staticClass:"my-avatar-text"},[_vm._v(_vm._s(_vm.text))]):_c('img',{staticClass:"my-avatar-img",attrs:{"src":_vm.img,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }